import httpApi from '@/utils/http-api'
import { api } from '@/config'
export default {
  getConfig: (query) => {
    return httpApi.getDataViaApi({
      url: api.cmsConfig.getConfig,
      queryParams: query
    })
  },
  getServicesPromotion () {
    return httpApi.getDataViaApi({
      url: api.cmsConfig.getServiceAndPromotion
    })
  }
}
